import React from "react";
import { Tooltip, Text, TextProps } from "@medentic/polaris-react";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/bg";
import useFormattedDate from "@shared/hooks/common/useFormattedDate";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

interface RenderDateProps {
  date: string;
  variant?: TextProps["variant"];
  isAgoFormat?: boolean;
  dayFirst?: boolean;
  reverseTooltip?: boolean;
}

const RenderDate: React.FC<RenderDateProps> = ({
  date,
  variant,
  isAgoFormat,
  dayFirst,
  reverseTooltip,
}) => {
  const { formattedDate, fromNow } = useFormattedDate({ date, dayFirst });

  const displayText = isAgoFormat ? fromNow : formattedDate;

  if (!date) return "";

  if (date.includes("***")) {
    return date;
  }

  return isAgoFormat ? (
    <Tooltip
      content={reverseTooltip ? displayText : formattedDate}
      hasUnderline
    >
      <p className="tooltip_container">
        <Text as="span" variant={variant ?? "bodyMd"}>
          {reverseTooltip ? formattedDate : displayText}
        </Text>
      </p>
    </Tooltip>
  ) : (
    <Text as="span" variant={variant ?? "bodyMd"}>
      {displayText}
    </Text>
  );
};

export default RenderDate;
